import {Component, TemplateRef} from '@angular/core';

import {ToastService} from './toast-service';

@Component({
    selector: 'app-toasts',
    template: `
      @for (toast of toastService.toasts; track toast; let i = $index) {
        <ngb-toast [class]="toast.classname"
                   [autohide]="true"
                   [delay]="toast.delay || 6000"
                   (hidden)="toastService.remove(toast)">
          @if (!(toast.type == 'success')) {
            <ng-template ngbToastHeader>
              <!--                <div *ngIf="toast.type == 'success'" class="me-auto">-->
              <!--                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"-->
              <!--                         class="bi bi-info-square me-2" viewBox="0 0 16 16">-->
              <!--                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>-->
              <!--                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>-->
              <!--                    </svg>-->
              <!--                    {{toast.header || 'การแจ้งเตือน'}}-->
              <!--                </div>-->
              @if (toast.type == 'info') {
                <div class="me-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-info-square me-2" viewBox="0 0 16 16">
                    <path
                      d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                    <path
                      d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                  </svg>
                  {{ toast.header || 'การแจ้งเตือน' }}
                </div>
              }
              @if (toast.type == 'warning') {
                <div class="me-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-lightbulb me-2" viewBox="0 0 16 16">
                    <path
                      d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z"/>
                  </svg>
                  {{ toast.header || 'การแจ้งเตือน' }}
                </div>
              }
              @if (toast.type == 'danger') {
                <div class="me-auto">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-lightning me-2" viewBox="0 0 16 16">
                    <path
                      d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5zM6.374 1 4.168 8.5H7.5a.5.5 0 0 1 .478.647L6.78 13.04 11.478 7H8a.5.5 0 0 1-.474-.658L9.306 1H6.374z"/>
                  </svg>
                  {{ toast.header || 'การแจ้งเตือน' }}
                </div>
              }
            </ng-template>
          }
          {{ toast.body }}
        </ngb-toast>
      }
    `,
    host: {'class': 'toast-container position-fixed top-0 end-0 p-3', 'style': 'z-index: 1200'}
})
export class ToastsContainer {

    constructor(public toastService: ToastService) {
    }

    isTemplate(toast: any) {
        return toast.textOrTpl instanceof TemplateRef;
    }
}
